import React, { useEffect, useState } from "react"
import CramLayout from "./CramLayout";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom"
import { HomeOutlined, ContactsOutlined, FileTextOutlined, NotificationOutlined, ReadOutlined } from '@ant-design/icons';
import axios from "axios";
import CourseLayout from './CourseLayout';
import { Breadcrumb, Layout, Menu, theme } from 'antd';
const { Header, Content, Sider } = Layout;
// const useAuth = () => {
//     //get item from localstorage
//     //後端api傳回身份管理
//     let user

//     const _user = localStorage.getItem("user")

//     if (_user) {
//         user = JSON.parse(_user)
//     }
//     if (user) {
//         return {
//             auth: true,
//             role: user.role,
//         }
//     } else {
//         return {
//             auth: false,
//             role: null,
//         }
//     }
// }

//protected Route state

const AdminCourseTab = (props) => {
    // const { auth, role, path } = useAuth()
    const [nav, setNav] = useState([]);
    const [li, setLi] = useState([]);
    const [identity, setIdentity] = useState([])
    const navigate = useNavigate();

    function getItem(label, key, icon, children, disabled, type) {
        return {
            key,
            icon,
            children,
            label,
            disabled,
            type
        };
    }
    const get_identity = () => {
        axios
            .get(`/cramSchool/api/permission`,)
            .then((response) => {
                setIdentity(response.data)
            })
    }
    useEffect(() => {
        get_identity();
    }, [])
    useEffect(() => {
        if (props.topic == 'admin') {
            setNav(
                []
            )

            setLi([
                getItem('Mercy後台管理', "/cramSchool/admin", <HomeOutlined />),
                getItem('課綱維護 ', '/cramSchool/admin/CourseOutlineManage', <ReadOutlined />),
                getItem('上課教材', '/cramSchool/admin/CourseMaterial', <ReadOutlined />),
                getItem('回家作業', '/cramSchool/admin/HomeWork', <ReadOutlined />),
                getItem('隨堂測驗', '/cramSchool/admin/Test', <ReadOutlined />),
                getItem('補課管理', '/cramSchool/admin/MakeUpCourseManage', <ReadOutlined />),
                getItem('學生總覽', '/cramSchool/admin/CourseStudentOverview', <ReadOutlined />),
                getItem('學生出席總覽', '/cramSchool/admin/CourseStudentAttendanceOverview', <ReadOutlined />),
                getItem('缺曠點名', '/cramSchool/admin/CourseStudentAttendance', <ReadOutlined />),
            ])

        }
    }, [identity]
    )

    //if the role required is there or not
    return (
        // auth ?
        //     (

        (
            <CourseLayout
                nav={nav}
                li={li}
                setLi={setLi}            >
                <Outlet />
            </CourseLayout>
        )

    )
}

export default AdminCourseTab;

